import React from 'react';
import {t} from '@lingui/core/macro';

import TelegramNotBackground from 'shared/ui/icons/TelegramNotBackground';

import styles from './LivePreview.module.scss';

const SPARK_HEIGHTS = [30, 26, 31, 22, 27, 20, 25, 18, 24, 16, 22, 14, 33, 40, 41];

const SPARK_POINTS = SPARK_HEIGHTS.map((y, index) => `${index * 20},${y}`).join(' ');

const LivePreview: React.FC = () => (
    <div className={styles.card} aria-hidden="true">
        <div className={styles.head}>
            <span className={styles.dot}/>
            <span className={styles.name}>{t`Ваш сайт`}</span>
            <span className={styles.state}>
                <span className={styles.ok}>{t`Работает`}</span>
                <span className={styles.fail}>{t`Сбой`}</span>
            </span>
        </div>
        <svg className={styles.spark} viewBox="0 0 280 44" preserveAspectRatio="none">
            <polyline className={styles.sparkLine} points={SPARK_POINTS}/>
        </svg>
        <div className={styles.foot}>
            <span>{t`Проверяем непрерывно`}</span>
            <span>{t`Сообщим за секунды`}</span>
        </div>
        <div className={styles.toast}>
            <span className={styles.toastIcon}><TelegramNotBackground/></span>
            {t`Отправили уведомление`}
        </div>
    </div>
);

export default LivePreview;
